const preventAnimationsAboveFold = (els: HTMLElement[]) => {
    const url = new URL(window.location.href);
    const isPCPage = url.pathname.includes('/pc/');

    const pageContentWrapper = document.querySelector<HTMLElement>('#content');
    const allPageModules = pageContentWrapper
        ? Array.from(pageContentWrapper.children)
        : [];

    els.forEach(el => {
        const containerEl = el.closest<HTMLElement>('[data-animation-container-el]');
        const modulePosition = allPageModules.findIndex(el => el === containerEl);
        const isAboveFold = modulePosition <= 1;

        if (isAboveFold || isPCPage) {
            el.removeAttribute('data-load-animation');
            containerEl?.removeAttribute('data-animation-container-el');
        }
    });
};

export default preventAnimationsAboveFold;
